import {
  Paper,
  Button,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Tooltip,
  IconButton,
} from "@mui/material";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import moment from "moment";
import TextField from "@mui/material/TextField";
import "./style.css";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import API from "../Api/api";
const columns = [
  {
    field: "code",
    headerName: "Code",
    width: 170,
  },
  {
    field: "status",
    headerName: "Status",
    width: 100,
  },
  {
    field: "date",
    headerName: "Date",
    width: 100,
  },
  {
    field: "description",
    headerName: "Description",
    width: 170,
  },
  {
    field: "received",
    headerName: "Received",
    width: 170,
  },
  {
    field: "branch",
    headerName: "Receiving Branch",
    width: 170,
  },
  {
    field: "sender_branch",
    headerName: "Sending Branch",
    width: 170,
  },
  {
    field: "amount",
    headerName: "Amount",
    width: 100,
  },
  {
    field: "submitted_by",
    headerName: "Submitted By",
    width: 170,
  },
];
function createData(
  id,
  code,
  status,
  date,
  description,
  received,
  branch,
  sender_branch,
  amount,
  submitted_by
) {
  return {
    id,
    code,
    status,
    date,
    description,
    received,
    branch,
    sender_branch,
    amount,
    submitted_by,
  };
}
export default function HeadOfficeReport() {
  const [showingData, setShowingData] = React.useState("all data");
  const location = useSelector((state) => state.location);
  const allAdviceData = useSelector((state) => state.allAdviceData);
  const [adviceData, setAdviceData] = React.useState(allAdviceData);
  const [adviceFilteringData, setAdviceFilteringData] =
    React.useState(allAdviceData);
  const [filterData, setFilterData] = React.useState({
    branch: "",
    start_date: "",
    end_date: "",
  });
  const rows = adviceData.map((data) =>
    createData(
      data._id,
      data.code,
      data.status,
      moment(data.date).format("DD-MM-YYYY"),
      data.description,
      data.received,
      data.receiving_branch,
      data.branch,
      data.amount?.toLocaleString(),
      data.submitted_by
    )
  );
  const branch = filterData.branch
    ? `&branch=${filterData.branch.toLocaleLowerCase()}`
    : "";
  const start_date = filterData.start_date
    ? `&date[gte]=${filterData.start_date}`
    : "";
  const end_date = filterData.end_date
    ? `&date[lte]=${filterData.end_date}`
    : "";
  const query = `/api/v1/company-advice?${branch}${start_date}${end_date}`;
  const query2 = `/api/v1/company-advice?receiving_branch[eq]=${filterData.branch}${start_date}${end_date}`;
  async function fetchData() {
    const res = await API.get(query);
    const res2 = await API.get(query2);
    const fetchedData = [...res.data, ...res2.data];
    setAdviceData(fetchedData);
    setAdviceFilteringData(fetchedData);
  }
  useEffect(() => {
    if (showingData === "from branches") {
      const need = adviceFilteringData.filter(
        (d) => d.branch !== "head office"
      );
      setAdviceData(need);
    }
    if (showingData === "to branches") {
      const need = adviceFilteringData.filter(
        (d) => d.branch === "head office"
      );
      setAdviceData(need);
    }
    if (showingData === "all data") {
      setAdviceData(allAdviceData);
    }
  }, [showingData]);
  const total_amount = adviceData.reduce((acc, val) => acc + val.amount, 0);
  function clearFilter() {
    setFilterData({
      branch: "",
      start_date: "",
      end_date: "",
    });
    setAdviceData(allAdviceData);
    setAdviceFilteringData(allAdviceData);
    setShowingData("all data");
  }
  return (
    <div>
      <div>
        <Paper
          style={{
            height: "10vh",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-around",
            backgroundColor: "#e4e4e5",
          }}>
          <FormControl size='small' style={{ width: "150px" }} fullWidth>
            <InputLabel id='demo-simple-select-label'>Branch</InputLabel>
            <Select
              required
              labelId='demo-simple-select-label'
              id='demo-simple-select'
              value={filterData.branch}
              label='Location'
              onChange={(e) =>
                setFilterData({ ...filterData, branch: e.target.value })
              }>
              <MenuItem value=''>
                <em>None</em>
              </MenuItem>
              {location.map((loc) => (
                <MenuItem key={loc._id} value={loc.location}>
                  {loc.location}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            type='date'
            label='Start date'
            value={filterData.start_date}
            onChange={(e) =>
              setFilterData({ ...filterData, start_date: e.target.value })
            }
            size='small'
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            type='date'
            label='End date'
            size='small'
            value={filterData.end_date}
            onChange={(e) =>
              setFilterData({ ...filterData, end_date: e.target.value })
            }
            InputLabelProps={{ shrink: true }}
          />
        </Paper>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            width: "100%",
          }}>
          <Button
            style={{ margin: "5px" }}
            variant='contained'
            onClick={fetchData}>
            submit
          </Button>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}>
            <div>
              <FormControl size='small'>
                <FormLabel
                  style={{ fontSize: "12px" }}
                  id='demo-row-radio-buttons-group-label'>
                  Showing
                </FormLabel>
                <RadioGroup
                  value={showingData}
                  onChange={(e) => setShowingData(e.target.value)}
                  row
                  aria-labelledby='demo-row-radio-buttons-group-label'
                  name='row-radio-buttons-group'>
                  <FormControlLabel
                    value='from branches'
                    control={<Radio size='small' />}
                    label='From Branches Data'
                  />
                  <FormControlLabel
                    value='to branches'
                    control={<Radio size='small' />}
                    label='To Branches Data'
                  />
                  <FormControlLabel
                    value='all data'
                    control={<Radio size='small' />}
                    label='All Data'
                  />
                </RadioGroup>
              </FormControl>
            </div>
          </div>
          <Tooltip title={<span>clear filter</span>}>
            <IconButton onClick={clearFilter}>
              <ClearAllIcon style={{ color: "red" }} />
            </IconButton>
          </Tooltip>
        </div>
        <DataGrid
          columns={columns}
          style={{ height: "68vh" }}
          rows={rows}
          slots={{ toolbar: GridToolbar }}
        />
        <strong style={{ marginLeft: "20px", textDecoration: "underline" }}>
          Total Amount: {total_amount.toLocaleString()}
        </strong>
      </div>
    </div>
  );
}
